import { FC } from "react";

import { PresentationBanner } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppDispatch, useAppSelector } from "store/index";
import { selectIsStudentPreview } from "store/selectors";
import { viewStateActions } from "store/slices/view";

export const StudentPreviewOptions: FC = () => {
  const showShortText = !useIsMdOrLarger();
  const isStudentPreview = useAppSelector(selectIsStudentPreview);
  const dispatch = useAppDispatch();

  if (!isStudentPreview) {
    return null;
  }

  return (
    <PresentationBanner
      bannerText={
        showShortText
          ? t("presentation.previewing_as_student_short")
          : t("presentation.previewing_as_student")
      }
      color="light-gray"
    >
      <PillButton
        eventName="Preview as Student - Stop"
        kind="banner-light-gray"
        size="s"
        onClick={() => dispatch(viewStateActions.setIsStudentPreview(false))}
      >
        {t("common.stop")}
      </PillButton>
    </PresentationBanner>
  );
};
